import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "linkComponent"];
import React from 'react';
import { StyledAdvancedSearch } from './advanced-search-link.styled';
export var AdvancedSearchLink = function AdvancedSearchLink(_ref) {
  var href = _ref.href,
    linkComponent = _ref.linkComponent,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledAdvancedSearch, _extends({
    linkComponent: linkComponent,
    "data-test-id": "search-dialog-advanced-search-link",
    href: href
  }, rest));
};